// extracted by mini-css-extract-plugin
module.exports = {"textPage":"TextPage_textPage__KDsAe","textPageContent":"TextPage_textPageContent__0ZFNK"};